export default "__VITE_ASSET__ChlbsqN0__"